import {useMutation} from 'react-query';
import useAlerts from '@/hooks/useAlerts';
import {useFilter} from '@/contexts/FilterContext';

const useExport = (service) => {
  const {search, filter: filters} = useFilter();
  const {putErrorCode} = useAlerts();

  const {mutateAsync: exportFile, isLoading: loading} = useMutation(async (format) => {
    const {data} = await service({search, filters, format});

    return data;
  }, {onError: putErrorCode});

  return {
    exportFile,
    loading,
  };
};

export default useExport;
